import React, { useMemo } from 'react'
import { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'
import { ResourceList } from '@/Core/UI/CrudResource/ResourceList'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { VehicleResource } from '../Resources/VehicleResource'
import { FaTruck } from 'react-icons/fa'

const VehiclePage: React.FC = () => {
    const listContext = useMemo(() => createCrudResourceContext({
        contextType: 'list',
        registryKey: 'Transport.Vehicle.list',
        resource: VehicleResource,
    } as any), [])

    return <ResourceList crudContext={listContext} />
}

export default VehiclePage

export const pageConfig: IPageConfig = {
    title: 'Транспортні засоби',
    icon: <FaTruck />,
}
